const FIRST = {
    a: "Jedi Master",
    b: "Captain", 
    c: "President", 
    d: "Ringleader", 
    e: "Wrangler", 
    f: "Executive Director", 
    g: "Queen", 
    h: "Curator",
    i: "Librarian", 
    j: "Head Ninja", 
    k: "Hero", 
    l: "Duke", 
    m: "Ambassador", 
    n: "Host", 
    o: "Project Coordinator",
    p: "Maestro", 
    q: "Lord", 
    r: "Instigator", 
    s: "Prefect", 
    t: "Luchador in Charge", 
    u: "Investigator", 
    v: "COO", 
    w: "Czar", 
    x: "CEO", 
    y: "Vice President", 
    z: "CFO"
}
const MIDDLE = {
    a: "Board Game Concepts",
    b: "Pizza Parties", 
    c: "Sequin Distribution", 
    d: "Coloring Outside the Lines", 
    e: "Scoundrels", 
    f: "Lazy River Tours", 
    g: "Unicorn Husbandry", 
    h: "Sarcasm & Snark",
    i: "Those Markers That Smell Good", 
    j: "Monopoly Fundraising", 
    k: "Finger Painting", 
    l: "Lego Masonry", 
    m: "Pun Development", 
    n: "Bad Decisions", 
    o: "Inappropriate Behavior",
    p: "Smoke Signal Marketing", 
    q: "Abstract Concepts", 
    r: "Competitive Eating Programs", 
    s: "Time Travel", 
    t: "Beatboxing", 
    u: "Bees?", 
    v: "Speaking in a Ridiculous Accent", 
    w: "Light Saber Manufacturing", 
    x: "Cartoon Physics", 
    y: "Pasta Design", 
    z: "Awesome Sauce"
}

const LAST = {
    a: "Ne'er Do Wells",
    b: "Puppy Partnerships", 
    c: "Axe Throwing", 
    d: "Teaching New Dogs Old Tricks", 
    e: "Tiddlywinks", 
    f: "Caffeine Delivery", 
    g: "Bubble Baths", 
    h: "Ukulele Musings",
    i: "Treasure Maps", 
    j: "Kaleidoscope Design", 
    k: "Turtle Talks", 
    l: "Punching the Holes in Donuts", 
    m: "Whimsy", 
    n: "Pretending to be Busy", 
    o: "Hide & Seek",
    p: "Measured Chaos", 
    q: "Funky Hats", 
    r: "French Fry Fanfare", 
    s: "Quirky Behavior", 
    t: "Naptime Plushie Distribution", 
    u: "Underwater Basket Weaving", 
    v: "Lobsters", 
    w: "Muppet Relations", 
    x: "Cheese Cutting", 
    y: "Blanket Fort Construction", 
    z: "Spontaneous Musical Numbers"
}

const MONTH = {
    January: "Museum",
    February: "Library", 
    March: "Academy",
    April: "Conservatory",
    May: "Gallery",
    June: "Hall",
    July: "Institute",
    August: "Garden",
    September: "Aquarium",
    October: "Zoo",
    November: "Theatre",
    December: "Exhibition"
}

const DATE = {
    1: "Feline Psychology", 
    2: "Science Magic", 
    3: "Sandbox Archaeology",
    4: "Vocal Farts", 
    5: "Medicinal Plants", 
    6: "Scatological Humor", 
    7: "Late Capitalism",
    8: "Spice World",
    9: "Scooby Snacks",
    10: "Whiskey Consumption",
    11: "Taco Operas",
    12: "Jigs, Rags, & Other Dances",
    13: "Penguin Advancement",
    14: "Dismantling Patriarchy", 
    15: "Sloths Racing Snails",
    16: "Equine Liberation", 
    17: "All Green Things",
    18: "Questionable Content",
    19: "Astrological Studies", 
    20: "Contemporary Sportsball",
    21: "Chocolate Chip Cookies",
    22: "Natural Herstory",
    23: "Popcorn Art",
    24: "Dinosaur Butts",
    25: "Inaccurate History",
    26: "Flintstones Technology",
    27: "Haberdashery Arts",
    28: "Ice Cream Sculpture", 
    29: "Historic Hogsmeade",
    30: "Late Night Sketch Comedy",
    31: "Batman"  
}

export { FIRST, MIDDLE, LAST, MONTH, DATE };